class Breakroom {
  constructor() {
    this.breakroom = document.querySelector("[data-breakroom]");
    this.el = document.querySelector("[data-brkrmpw]");
    this.storage = localStorage.getItem("breakroom");

    if (this.breakroom && this.el) {
      this._init();
    }
  }

  _init() {
    this.password = this.el.getAttribute("data-brkrmpw");
    this.login = document.querySelector("[data-breakroom-login]");
    this.form = document.querySelector("[data-breakroom-form]");
    this.input = document.querySelector("[data-breakroom-input]");
    this.submit = document.querySelector("[data-breakroom-submit]");

    if (this.storage === this.password) {
      this.login.parentNode.removeChild(this.login);
      this._confirm(true);
      return;
    }

    this.el.parentNode.removeChild(this.el);
    this.form.addEventListener("submit", this._handleSubmit.bind(this));
  }

  _handleSubmit(event) {
    event.preventDefault();
    this.submit.classList.add("disabled");
    const confirm = this._confirm.bind(this);

    window.setTimeout(() => {
      if (this.input.value === this.password) {
        confirm();
      } else {
        window.alert("Password is incorrect");
      }
      this.submit.classList.remove("disabled");
    }, 800);
  }

  _confirm(storage) {
    this.breakroom.classList.add("breakroom--success");
    if (!storage) {
      this.login.parentNode.replaceChild(this.el, this.login);
    }
    window.scrollTo(0, 0);
    localStorage.setItem("breakroom", this.password);
  }
}

export default Breakroom;
